export enum CreatePathwayError {
    ALREADY_CREATED = 'already been created for member',
}
